import type { IntercomBootProps } from 'react-use-intercom';
import { INTERCOM_APP_ID } from '@utils/constants';
import type { UserCompany } from '@kiute-tech/network-kiute-pro';

export const formatIntercomUser = (
    userInfo: UserCompany,
): IntercomBootProps => {
    const { PUBLIC_URL } = process.env;
    const company = userInfo?.company;
    return {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        appId: INTERCOM_APP_ID,
        hideDefaultLauncher: true,
        userId: userInfo?.id,
        name: `${userInfo?.firstName} ${userInfo?.lastName}`,
        createdAt: String(company?.timeCreated),
        email: userInfo?.email,
        phone: userInfo.phone,
        company: {
            companyId: company?.code ?? '',
            name: company?.name,
            createdAt: String(company?.timeCreated),
            plan: company?.companyOfferResponse?.code,
            industry: company?.businessModel,
            monthlySpend: company?.companyOfferResponse?.price,
            website: company?.code ? `${PUBLIC_URL}/${company?.code}` : '#',
        },
        customAttributes: {
            connectUrl: company?.code
                ? `${PUBLIC_URL}fxbAdmin/ ${company?.code}`
                : '#',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            mangopay_ID: company?.pspUserId,
            country: company?.country,
        },
    };
};
